import { PropsWithChildren } from "react";
import { accentColor, sectionTitle } from "./styles.css";

export const SectionTitle = ({ children }: PropsWithChildren) => (
  <h2 className={sectionTitle}>{children}</h2>
);

export const AccentText = ({ children }: PropsWithChildren) => (
  <span className={accentColor}>{children}</span>
);
